<template>
  <f7-page class="page-setup-display">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Trở lại"></f7-nav-left>
      <f7-nav-title sliding>CÀI ĐẶT HIỂN THỊ</f7-nav-title>
    </f7-navbar>
    <f7-block-title>KÍCH CỠ FONT CHỮ</f7-block-title>
    <f7-block inset strong>
      <f7-range
          :min="12"
          :max="20"
          :label="true"
          :step="1"
          :value="_.isUndefined(user_info.user_configs.font_size) ? 14 : user_info.user_configs.font_size"
          :scale="true"
          :scale-steps="1"
          :scale-sub-steps="1"
          @range:changed="changeFontSize"
      ></f7-range>
    </f7-block>
    <f7-list inset inline-labels>
      <f7-list-item title="Hiển thị quảng cáo">
        <f7-icon slot="media" ios="f7:cube" color="crimson"></f7-icon>
        <f7-toggle slot="after" :checked="!!user_info.user_configs.display_advertise"
                   @toggle:change="toggleAdv"></f7-toggle>
      </f7-list-item>
    </f7-list>
  </f7-page>
</template>
<script>
import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState(['user_info'])
  },
  data() {
    return {}
  },
  methods: {
    changeFontSize(font_size) {
      this.user_info.user_configs.font_size = parseInt(font_size);

      this.$store.dispatch('changeMeConfig', this.user_info.user_configs).catch((err) => {
        this.$f7.dialog.alert(err, 'LỖI!');
      })
    },
    toggleAdv(val) {
      this.user_info.user_configs.display_advertise = val ? 1 : 0;

      this.$store.dispatch('changeMeConfig', this.user_info.user_configs).catch((err) => {
        this.$f7.dialog.alert(err, 'LỖI!');
      })
    },
  }
};
</script>
